export default {
  positiveTitle: {
    id: 'review_funnel_review_summary_positive_title',
    defaultMessage: 'We appreciate your thoughts.',
  },
  positiveSubtitle: {
    id: 'review_funnel_review_summary_positive_subtitle',
    defaultMessage:
      'Your review is live. Thanks for taking the time to drop us a line.',
  },
  negativeTitle: {
    id: 'review_collection_summary_title_negative',
    defaultMessage: 'Thanks for telling it like it is.',
  },
  negativeSubtitle: {
    id: 'review_collection_summary_text_negative',
    defaultMessage:
      'We know it took time and effort to share your experience and it won’t get lost in the abyss. This is the kind of stuff that helps us improve.',
  },
} as const
